import { render, staticRenderFns } from "./VendorsReport.vue?vue&type=template&id=7294e2fa"
import script from "./VendorsReport.vue?vue&type=script&lang=ts"
export * from "./VendorsReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports